import React, { useEffect, useState } from "react";
import { Card, CardTitle } from "../components/ui/Card";
import { QrCode } from "../components/QrCode";
import { baseUrl } from "../config";

const buildJoinUrl = (hostname: string): string => {
  const { protocol, port } = window.location;
  const portSuffix = port ? `:${port}` : "";
  return `${protocol}//${hostname}${portSuffix}/`;
};

export const JoinPage: React.FC = () => {
  const [hostname, setHostname] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/network/info`);
        if (!response.ok) {
          throw new Error(`Hostname-Anfrage fehlgeschlagen (${response.status})`);
        }
        const data = (await response.json()) as { hostname?: string };
        if (!cancelled) {
          setHostname(data.hostname || window.location.hostname);
        }
      } catch {
        if (!cancelled) {
          setHostname(window.location.hostname);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const joinUrl = hostname ? buildJoinUrl(hostname) : "";

  return (
    <div className="flex justify-center p-4">
      <Card className="flex w-full max-w-screen flex-col items-center gap-4">
        <CardTitle className="w-full">Beitreten</CardTitle>
        {isLoading ? (
          <div
            data-cy="join-loading"
            role="status"
            aria-label="Lädt"
            className="h-60 w-60 animate-pulse rounded-control bg-ink/10"
          />
        ) : (
          <>
            <QrCode
              value={joinUrl}
              size={240}
              className="rounded-control border border-line"
            />
            <p className="break-all text-center text-sm text-ink-muted">
              QR-Code scannen, um dich aus dem Netzwerk zu verbinden.
            </p>
            <p className="break-all text-center text-sm font-bold text-ink">
              {joinUrl}
            </p>
          </>
        )}
      </Card>
    </div>
  );
};
